import { Authorization } from '../pages/Auth/Authorization.jsx';
import { MainPage } from '../modules/main-page/index.jsx';
import { ApiKey } from '@/modules/api-key/index.jsx';
import { Console } from '@/modules/console/index.jsx';
import { ShareView } from '@/pages/ShareView.jsx';
import { GuestShareView } from '@/pages/GuestShareView.jsx';
import { VerifyView } from '@/pages/VerifyView.jsx';
import { Files } from '../modules/files/index.jsx';
import { MyDocs } from '@/modules/my-docs/index.jsx';
import { Shared } from '@/modules/shared/index.jsx';
import { TemplateLibraryPage } from '@/modules/templates/pages/TemplateLibraryPage.jsx';
import { RecordsPage } from '@/modules/records/pages/RecordsPage.jsx';
import { JournalPrintPage } from '@/modules/records/pages/JournalPrintPage.jsx';
import { AgentPanelPage } from '@/modules/assistant/pages/AgentPanelPage.jsx';

// Embed pages
import EmbedConsole from '@/pages/embed/EmbedConsole.jsx';
import EmbedDocs from '@/pages/embed/EmbedDocs.jsx';
import EmbedMyDocs from '@/pages/embed/EmbedMyDocs.jsx';
import EmbedLiveEdit from '@/pages/embed/EmbedLiveEdit.jsx';
import EmbedSign from '@/pages/embed/EmbedSign.jsx';
import { withEmbedAuth } from '@/shared/components/EmbedRoute.jsx';

export const routes = [
  {
    path: '/',
    component: Authorization,
    noLayer: true,
    protectedBy: 'guest',
  },
  {
    path: '/projects',
    component: MainPage,
    protectedBy: 'root',
  },
  {
    path: '/auth',
    component: Authorization,
    noLayer: true,
    protectedBy: 'guest',
  },
  {
    path: '/share/:token',
    component: ShareView,
    noLayer: true,
    protectedBy: 'always',
  },
  {
    path: '/guest-share/:token',
    component: GuestShareView,
    noLayer: true,
    protectedBy: 'always',
  },
  {
    // What the QR stamped on a signed document opens: public verification
    // page, no portal, optional guest E-IMZO login for restricted documents.
    path: '/v/:code',
    component: VerifyView,
    noLayer: true,
    protectedBy: 'always',
  },
  {
    // Legacy route — redirects into the console's API Keys tab.
    path: '/:id/api-key',
    component: ApiKey,
    protectedBy: 'root',
  },
  {
    path: '/:id/console',
    component: Console,
    protectedBy: 'root',
  },
  {
    path: '/files/:id',
    component: Files,
    protectedBy: 'iframe',
  },
  {
    path: '/my-docs',
    component: MyDocs,
    protectedBy: 'any-auth',
  },
  {
    // The template library: templates are a project resource, never in the
    // folder tree — managed here, used from the "+ New" picker.
    path: '/templates',
    component: TemplateLibraryPage,
    protectedBy: 'any-auth',
  },
  {
    // The departmental archive: file plans and their cases. The page itself
    // says so when records management is off or the person has no access.
    path: '/records',
    component: RecordsPage,
    protectedBy: 'any-auth',
  },
  {
    // A journal laid out for paper — no app chrome around it.
    path: '/records/journals/:id/print',
    component: JournalPrintPage,
    noLayer: true,
    protectedBy: 'any-auth',
  },
  {
    // Rendered inside the Collabora editor's agent dock iframe (branding.js).
    path: '/agent-panel',
    component: AgentPanelPage,
    noLayer: true,
    protectedBy: 'any-auth',
  },
  {
    path: '/shared-docs',
    component: Shared,
    protectedBy: 'iframe',
  },
  // ============================================
  // Embed Routes (iframe integration)
  // ============================================
  {
    path: '/embed/docs',
    component: withEmbedAuth(EmbedDocs),
    noLayer: true,
    protectedBy: 'iframe',
  },
  {
    path: '/embed/my-docs',
    component: withEmbedAuth(EmbedMyDocs),
    noLayer: true,
    protectedBy: 'iframe',
  },
  {
    // Office-portal admin surface: project-less; the console token binds
    // the project (see /embed/v1/console/context).
    path: '/embed/console',
    component: withEmbedAuth(EmbedConsole),
    noLayer: true,
    protectedBy: 'iframe',
  },
  {
    path: '/embed/live-edit',
    component: withEmbedAuth(EmbedLiveEdit),
    noLayer: true,
    protectedBy: 'iframe',
  },
  {
    // One document's E-IMZO signing, framed by a module (zehn/hr) so the
    // module needs no E-IMZO API key of its own — see EmbedSign.
    path: '/embed/sign',
    component: withEmbedAuth(EmbedSign),
    noLayer: true,
    protectedBy: 'iframe',
  },
];
